module.exports = "<div class=\"panel\">\n  <div class=\"panel-heading\">\n    <h2 class=\"panel-title\">{{ title }}</h2>\n    <button class=\"btn btn-primary\"\n      [routerLink]=\"['/news', 'new']\" id=\"btn_addNews\">\n      {{ addButtonText }}\n    </button>\n  </div>\n\n  <div class=\"panel-body\">\n    <cms-table></cms-table>\n    <!--<router-outlet></router-outlet>-->\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/noticias/news-list/news-list.component.html
// module id = ./src/app/noticias/news-list/news-list.component.html
// module chunks = main